const CARDHOLDER_PREFIX = 'card-holder';

export enum CardFeesEnum {
    MEMBERSHIP_FEE = "membership",
    CUSTOMIZATION_FEES = "customization-fees",
    RENEWAL_FEE = "renewal",
    REPLACEMENT_FEE = "replacement",
    PIN_RECALCULATION_FEE = "pin-recalculation",
    RECURRING_FEE = "recurring",
    ONE_TIME_FEE = "one-time",
}

// Cardholder Management config Routes
function cardHolder(prefix: string) {
    // PARAMETERS Menu Settings Routes
    const PARAMETERS_PATH = `${prefix}/parameters/`;
    
    const PARAMETERS_MENU = {
        ROOT: PARAMETERS_PATH,
        REASON_CARD_REPLACEMENT: `${PARAMETERS_PATH}reason-card-replacement`,
        
        REASON_STOPPING_AUTOMATIC_CARD_RENEWAL: `${PARAMETERS_PATH}reason-for-stopping-automatic-card-renewal`,
        
        REASON_CARD_STATUS: `${PARAMETERS_PATH}reason-card-status`,
        
        REASON_CUSTOMER_STATUS: `${PARAMETERS_PATH}reason-for-customer-status`,
        
    };

    const CARD_OPERATIONS_PATH = `${prefix}/card-operations/`;

    const CARD_OPERATIONS_MENU = {
        ROOT: CARD_OPERATIONS_PATH,

        CARD_RENEWAL: `${CARD_OPERATIONS_PATH}card-renewal`,

        CARD_REPLACEMENT: `${CARD_OPERATIONS_PATH}card-replacement`,

        OPPOSITION_DETAIL: `${CARD_OPERATIONS_PATH}opposition/detail/`,

        PIN_RESET: `${CARD_OPERATIONS_PATH}pin-reset`,

        PIN_RECALCULATION_OPERATION: `${CARD_OPERATIONS_PATH}pin-recalculation-operation`,

        RENEWAL_MODE_CHANGE: `${CARD_OPERATIONS_PATH}renewal-mode-change`,

        CARD_STATUS_CHANGE: `${CARD_OPERATIONS_PATH}card-status-change`,

        CUSTOMER_STATUS_CHANGE: `${CARD_OPERATIONS_PATH}customer-status-change`,

        OPPOSITION: `${CARD_OPERATIONS_PATH}opposition/`,

        SERVICE_TRANSFER_ENROLLMENT: `${CARD_OPERATIONS_PATH}service-transfer-enrollment`,
    }

    // CARD FEES Menu Settings Routes
    const CARD_FEES_PATH = `${prefix}/card-fees/`;
    const COMMON_CARD_FEES_PATH = `${CARD_FEES_PATH}common/`;
    
    const CARD_FEES_MENU = {
        ROOT: CARD_FEES_PATH,
        COMMON: COMMON_CARD_FEES_PATH,
        MEMBERSHIP_FEE: `${COMMON_CARD_FEES_PATH}${CardFeesEnum.MEMBERSHIP_FEE}`,
        
        CUSTOMIZATION_FEES: `${COMMON_CARD_FEES_PATH}${CardFeesEnum.CUSTOMIZATION_FEES}`,
        
        RENEWAL_FEE: `${COMMON_CARD_FEES_PATH}${CardFeesEnum.RENEWAL_FEE}`,
        
        REPLACEMENT_FEE: `${COMMON_CARD_FEES_PATH}${CardFeesEnum.REPLACEMENT_FEE}`,
        
        PIN_RECALCULATION_FEE: `${COMMON_CARD_FEES_PATH}${CardFeesEnum.PIN_RECALCULATION_FEE}`,
        
        MISCELLANEOUS_FEE: `${CARD_FEES_PATH}miscellaneous/`,
        
        CARD_COMMISSION: `${CARD_FEES_PATH}card-commission`,
        

    };

    // CARD DATA Menu Settings Routes
    const CARD_DATA_PATH = `${prefix}/card-data/`;
    const CARD_DATA_MENU = {
        ROOT: CARD_DATA_PATH,
        CARD_PRODUCT: `${CARD_DATA_PATH}card-product`,
        CUSTOMER: `${CARD_DATA_PATH}customer`,
        CUSTOMER_DETAIL: `${CARD_DATA_PATH}customer/detail/`,
        ACCOUNT: `${CARD_DATA_PATH}account`,
        ACCOUNT_DETAIL: `${CARD_DATA_PATH}account/detail/`,
        CARD: `${CARD_DATA_PATH}card`,
        CARD_DATA: `${CARD_DATA_PATH}card/card-data`,
        CARD_CONSULTATION: `${CARD_DATA_PATH}card-consultation`,
        CARD_STATUS_CONSULTATION: `${CARD_DATA_PATH}card-status-consultation`,
        CARD_STATUS_HISTORY: `${CARD_DATA_PATH}card-status-history`,
        HISTORY_RESET_PIN_COUNTER: `${CARD_DATA_PATH}history-reset-pin-counter`,
        "3D_SECURE_HISTORY": `${CARD_DATA_PATH}3d-secure-history`,
    };

    function cardPersonalizationRoutes(prefix: string) {
        const CARD_PERSONALIZATION_PATH = `${prefix}/card-personalization`;        
        return {
            CARD_PERSONALIZATION_MENU:{
                // personalisation des cartes
                ROOT:CARD_PERSONALIZATION_PATH,
                // consultation personalisation incomplete
                INCOMPLETE_PERSONALIZATION_CONSULTATION: `${CARD_PERSONALIZATION_PATH}/incomplete-personalization-consultation`,
                // validation pre-personalisation
                PRE_PERSONALIZATION_VALIDATION: `${CARD_PERSONALIZATION_PATH}/pre-personalization-validation`,
                // envoi lot de personalisation
                SENDING_PERSONALIZATION_BATCH: `${CARD_PERSONALIZATION_PATH}/sending-personalization-batch`,
                // retour lot de personalisation 
                RETURN_PERSONALIZATION_BATCH: `${CARD_PERSONALIZATION_PATH}/return-personalization-batch`,
            }
        }
    }

    return {
        ROOT: prefix,
        PARAMETERS_MENU,
        CARD_FEES_MENU,
        CARD_DATA_MENU,
        ...cardPersonalizationRoutes(prefix),
        CARD_OPERATIONS_MENU
    }
}

// Prepaid Card Management config Routes
function prepaid(prefix: string) {
    function globalParametersRoutes(prefix: string) {
        const GLOBAL_PARAMETERS_PATH = `${prefix}/global-parameters`;
        const AUTOMATIC_RECHARGE_STOP_REASON_PATH = `${GLOBAL_PARAMETERS_PATH}/automatic-recharge-stop-reason`;
        const RECHARGE_FEES_PATH = `${GLOBAL_PARAMETERS_PATH}/recharge-fees`;
        const MISCELLANEOUS_PERIODIC_COSTS_PATH = `${GLOBAL_PARAMETERS_PATH}/miscellaneous-periodic-costs`;
        const ANONYMOUS_CARD_AGENCY_ACCOUNT_PATH = `${GLOBAL_PARAMETERS_PATH}/anonymous-card-agency-account`;
        
        return {
            GLOBAL_PARAMETERS:{
                ROOT:GLOBAL_PARAMETERS_PATH,
                AUTOMATIC_RECHARGE_STOP_REASON: AUTOMATIC_RECHARGE_STOP_REASON_PATH,
                RECHARGE_FEES: RECHARGE_FEES_PATH,
                MISCELLANEOUS_PERIODIC_COSTS: MISCELLANEOUS_PERIODIC_COSTS_PATH,
                ANONYMOUS_CARD_AGENCY_ACCOUNT: ANONYMOUS_CARD_AGENCY_ACCOUNT_PATH,
            }
        }
    }

    function cardRoutes(prefix: string) {
        const CARD_PATH = `${prefix}/card`;
        const ANONYMOUS_CARD_PRODUCTION_PATH = `${CARD_PATH}/anonymous-card-production`;
        const CONSULT_ANONYMOUS_CARD_PATH = `${CARD_PATH}/consult-anonymous-card`;
        const CONSULT_PREPAID_TRANSACTION_PATH = `${CARD_PATH}/consult-prepaid-transaction`;
        
        return {
            CARD:{
                ROOT:CARD_PATH,
                ANONYMOUS_CARD_PRODUCTION: ANONYMOUS_CARD_PRODUCTION_PATH,
                CONSULT_ANONYMOUS_CARD: CONSULT_ANONYMOUS_CARD_PATH,
                CONSULT_PREPAID_TRANSACTION: CONSULT_PREPAID_TRANSACTION_PATH,
                CONSULT_PREPAID_TRANSACTION_DETAILS: `${CONSULT_PREPAID_TRANSACTION_PATH}/details/`,
            }
        }
    }

    function prepaidOperationsRoutes(prefix: string) {
        const PREPAID_OPERATIONS_PATH = `${prefix}/prepaid-operations`;
        const DISABLE_AUTOMATIC_RECHARGE_PATH = `${PREPAID_OPERATIONS_PATH}/disable-automatic-recharge`;
        const ENABLE_AUTOMATIC_RECHARGE_PATH = `${PREPAID_OPERATIONS_PATH}/enable-automatic-recharge`;
        const MANUAL_CARD_TOP_UP_PATH = `${PREPAID_OPERATIONS_PATH}/manual-card-top-up`;
        
        return {
            PREPAID_OPERATIONS:{
                ROOT:PREPAID_OPERATIONS_PATH,
                DISABLE_AUTOMATIC_RECHARGE: DISABLE_AUTOMATIC_RECHARGE_PATH,
                ENABLE_AUTOMATIC_RECHARGE: ENABLE_AUTOMATIC_RECHARGE_PATH,
                MANUAL_CARD_TOP_UP: MANUAL_CARD_TOP_UP_PATH,
            }
        }
    }

    function companyRoutes(prefix: string) {
        const COMPANY_PATH = `${prefix}/company`;
        const COMPANY_DATA_PATH = `${COMPANY_PATH}/company-data`;
        const SALARY_FILE_PATH = `${COMPANY_PATH}/salary-file`;
        const SALARY_FILE_DETAILS_PATH = `${COMPANY_PATH}/salary-file-details`;
        
        return {
            COMPANY:{
                ROOT:COMPANY_PATH,
                COMPANY_DATA: COMPANY_DATA_PATH,
                SALARY_FILE: SALARY_FILE_PATH,
                SALARY_FILE_DETAILS: SALARY_FILE_DETAILS_PATH,
            }
        }
    }

    

    return {
        ROOT: prefix,
        ...globalParametersRoutes(prefix),
        ...cardRoutes(prefix),
        ...prepaidOperationsRoutes(prefix),
        ...companyRoutes(prefix),
        ...cardHolderRoutes(prefix),
    }   
}

function cardHolderRoutes(prefix: string) {
    const CARD_HOLDER_PATH = `${prefix}/card-holder`;
    const PREPAID_APPLICATION_SUBMENU = `${CARD_HOLDER_PATH}/prepaid-application`;

    return {
        CARD_HOLDER:{
            ROOT:`${CARD_HOLDER_PATH}`,
            PREPAID_PROGRAM: `${CARD_HOLDER_PATH}/prepaid-program`,
            PREPAID_APPLICATION: {
                ROOT: `${PREPAID_APPLICATION_SUBMENU}`,
                PREPAID_APPLICATION: `${PREPAID_APPLICATION_SUBMENU}/prepaid-application`,
                CONSULT_PREPAID_APPLICATION: `${PREPAID_APPLICATION_SUBMENU}/consult-prepaid-application`,
            },
            PREPAID_APPLICATION_VALIDATION: `${CARD_HOLDER_PATH}/prepaid-application-validation`,
            ANONYMOUS_CARD_HOLDER: `${CARD_HOLDER_PATH}/anonymous-card-holder`,
            CONSULT_PREPAID_DATA: `${CARD_HOLDER_PATH}/consult-prepaid-data`,
            CHANGE_ANONYMOUS_CARD_AGENCY: `${CARD_HOLDER_PATH}/change-anonymous-card-agency`,
        }
    }
}

// Debit Card Management config Routes
function debit(prefix: string) {
    // GLOBAL SETTINGS Menu Settings Routes
    const GLOBAL_SETTINGS_PATH = `${prefix}/global-settings/`;
    
    const GLOBAL_SETTINGS_MENU = {
        ROOT: GLOBAL_SETTINGS_PATH,
        PERIODIC_MISCELLANEOUS_FEES: `${GLOBAL_SETTINGS_PATH}periodic-miscellaneous-fees`,
        ACCOUNT_STATUS_REASON: `${GLOBAL_SETTINGS_PATH}account-status-reason`,
    };

    // HOLDER MANAGEMENT Menu Settings Routes
    const HOLDER_MANAGEMENT_PATH = `${prefix}/holder-management/`;
    const DEBIT_APPLICATION_PATH = `${HOLDER_MANAGEMENT_PATH}debit-application/`;
    const DEBIT_APPLICATION_MENU = {
        ROOT: DEBIT_APPLICATION_PATH,
        DEBIT_APPLICATION: `${DEBIT_APPLICATION_PATH}debit-application`,
        DEBIT_APPLICATION_CONSULTATION: `${DEBIT_APPLICATION_PATH}debit-application-consultation`,
    };
    
    const HOLDER_MANAGEMENT_MENU = {
        ROOT: HOLDER_MANAGEMENT_PATH,
        DEBIT_APPLICATION_MENU,
        DEBIT_APPLICATION_VALIDATION: `${HOLDER_MANAGEMENT_PATH}debit-application-validation`,
    };

    // DEBIT OPERATIONS Menu Settings Routes
    const DEBIT_OPERATIONS_PATH = `${prefix}/debit-operations/`;
    
    
    const DEBIT_OPERATIONS_MENU = {
        ROOT: DEBIT_OPERATIONS_PATH,
        ADD_NEW_ACCOUNT: `${DEBIT_OPERATIONS_PATH}add-new-account`,
        CARD_ACCOUNT_LINK: `${DEBIT_OPERATIONS_PATH}card-account-link`,
        TRNFR_CARD_ACCOUNT_LINK: `${DEBIT_OPERATIONS_PATH}trnfr-card-account-link`,
        ACCOUNT_LIST: `${DEBIT_OPERATIONS_PATH}account-list`,
        TRANSFER_ACCOUNT_LIST: `${DEBIT_OPERATIONS_PATH}transfer_account-list`,
    };

    return {
        ROOT: prefix,
        GLOBAL_SETTINGS_MENU,
        HOLDER_MANAGEMENT_MENU,
        DEBIT_OPERATIONS_MENU,
    }
}

// Smart Management config Routes
function smart(prefix: string) {
    
    function globalParametersRoutes(prefix: string) {
        const GLOBAL_PARAMETERS_PATH = `${prefix}/global-parameters`;
        const PROFILE_APPLICATION_PATH = `${GLOBAL_PARAMETERS_PATH}/profile-application`;
        const PARAMETERS_SCRIPT_PROCESSING_MENU = `${GLOBAL_PARAMETERS_PATH}/parameters-script-processing`;

        return {
            GLOBAL_PARAMETERS:{
                ROOT:GLOBAL_PARAMETERS_PATH,
                PROFILE_APPLICATION: PROFILE_APPLICATION_PATH,
                PARAMETERS_SCRIPT_PROCESSING:PARAMETERS_SCRIPT_PROCESSING_MENU,
            }
        }
    }

    function scriptProcessingRoutes(prefix: string) {
        const SCRIPT_PROCESSING_PATH = `${prefix}/script-processing`;
        const RULES_MENU = `${SCRIPT_PROCESSING_PATH}/rules`;
        const CONSULTATION_PATH = `${SCRIPT_PROCESSING_PATH}/consultation`;
        const CARD_UPDATE_PATH = `${SCRIPT_PROCESSING_PATH}/card-update`;
        const CARD_UPDATE_PER_BIN_PATH = `${SCRIPT_PROCESSING_PATH}/card-update-per-bin`;
        
        return {
            SCRIPT_PROCESSING:{
                ROOT:SCRIPT_PROCESSING_PATH,                
                RULES: RULES_MENU,
                CONSULTATION:CONSULTATION_PATH,
                ORDER:`${CONSULTATION_PATH}/order/`,
                CARD_UPDATE:CARD_UPDATE_PATH,
                CARD_UPDATE_PER_BIN:CARD_UPDATE_PER_BIN_PATH,
            }
        }
    }

    function batchesRoutes(prefix: string) {
          // BATCHES Menu Routes
        const BATCHES_PATH = `${prefix}/batches/`;
        
        return {
            BATCHES: {
                ROOT: BATCHES_PATH,
                BATCHES_MONITORING: `${BATCHES_PATH}monitoring`,
                BATCHES_ERRORS: `${BATCHES_PATH}errors`,
                BATCHES_TRACES: `${BATCHES_PATH}traces`,
            }
        }
    }

    return {
        ROOT: prefix,
        ...globalParametersRoutes(prefix),
        ...scriptProcessingRoutes(prefix),
        ...batchesRoutes(prefix),
    }   
}


export function cardManagementSystem(prefix: string) {
    return {
        ROOT: prefix,

        // Card Holder
        CARDHOLDER: {
            ...cardHolder(`${prefix}/${CARDHOLDER_PREFIX}`)
        },
        
        // Prepaid
        PREPAID: {
            ...prepaid(`${prefix}/prepaid`)
        },

        // Debit
        DEBIT: {
            ...debit(`${prefix}/${CARDHOLDER_PREFIX}`)
        },

        // Smart
        CARDSMARTHOLDER: {
            ...smart(`${prefix}/smart`)
        },
        
    }
}